// extracted by mini-css-extract-plugin
export default {"paper":"CustomerDialog_paper__ML4F5"};